import { IPayment } from "@/apps/merchant3/models/IPayment";

const getters = {
  paymentInfo: (state: IPayment): IPayment => state,
  paymentId: (state: IPayment): string | null => {
    if (state.paymentPayload?.paymentId) {
      return `${state.paymentPayload.paymentId}`;
    }
    return null;
  },
};

export default getters;
